module.exports = __webpack_public_path__ + "img/scene.2.1fd2e04f.jpg";